import { createReducer, on, Action } from '@ngrx/store';

import { HistoryModuleState } from '../models/history.model';
import * as historyActions from '../store/history.actions';

export const initialState = [] as HistoryModuleState;

const historyReducer = createReducer(
  initialState,
  on(historyActions.getHistorySuccess, (_, { history }) => [...history]),
);

export const reducer = (state: HistoryModuleState | undefined, action: Action) =>
  historyReducer(state, action);
